export const inferLoginChannel = (profile) => {
  if (!profile) return null;
  if (profile.telegram_chat_id) return "telegram";
  if (profile.email) return "email";
  if (profile.phone) return "text";
  return null;
};

export const getDefaultNotificationChannels = (profile) => {
  const channels = ["push"];
  const method = inferLoginChannel(profile);
  if (method && !channels.includes(method)) channels.push(method);
  return channels;
};

export const getEffectiveNotificationChannels = (profile) => {
  if (profile?.notification_channels?.length) {
    return profile.notification_channels;
  }
  return getDefaultNotificationChannels(profile);
};

export const getEffectiveAllergies = (profile) => {
  if (profile?.allergies?.length) {
    return profile.allergies;
  }
  return [];
};
